<template>
  <div class="container">
    <div class="handle-wrapper">
      <Input
        v-model="searchText"
        search
        placeholder="搜索客户..."
        @on-change="searchSalesContract"
        clearable
        icon="ios-search"
        style="width: 250px; margin-right: auto"
      ></Input>
      <!-- <span>共{{ totalRows }}条</span> -->
      <!-- <Page
        :total="totalRows"
        :page-size="15"
        @on-change="loadSales"
        show-total
        simple
        style="margin-right: 24px"
      />-->
      <Button
        v-if="
          currentUser.superAdmin ||
          arrayIntersection(['salesAssist'], currentUser.simpleRole).length > 0
        "
        type="primary"
        @click="openCreateSalesContractDrawer()"
      >新增销售合同</Button>
    </div>
    <div class="table-wrapper">
      <Table :columns="columns" :data="tableData">
        <template
          slot-scope="{ row }"
          slot="action"
          v-if="
            currentUser.superAdmin ||
            arrayIntersection(
              [
                'factoryLeader',
                'technologyLead',
                'technology',
                'allFactoryLeader',
              ],
              currentUser.simpleRole
            ).length > 0
          "
        >
          <Button
            type="info"
            ghost
            size="small"
            icon="ios-funnel"
            @click="$refs.RecipeDrawer.openDrawer(row)"
          >配方</Button>
        </template>
      </Table>
    </div>
    <CreateSalesContractDrawer ref="CreateSalesContractDrawer" />
    <SalesContractDetailDrawer ref="SalesContractDetailDrawer" />
  </div>
</template>

<script>
import { arrayIntersection } from "@/utils";
import { mapState, mapActions } from "vuex";
import CreateSalesContractDrawer from "./CreateSalesContractDrawer.vue";
import SalesContractDetailDrawer from "./SalesContractDetailDrawer.vue";

export default {
  name: "SalesContract",
  components: { CreateSalesContractDrawer, SalesContractDetailDrawer },
  data() {
    return {
      searchText: "",
      columns: [
        {
          title: "合同编号",
          key: "number",
          align: "left",
          render: (h, params) => h("span", { style: { color: "darkgray" } }, 22)
        },
        {
          title: "客户",
          key: "customer",
          align: "left",
          render: (h, params) => {
            return h(
              "div",
              {
                style: { color: "#42b983", cursor: "pointer" },
                on: {
                  click: () => {
                    this.$refs.CalcSalesDetailDrawer.openDrawer(params.row);
                  }
                }
              },
              params.row.customer.name
            );
          }
        }
      ]
    };
  },
  computed: mapState({
    tableData: state => state.sales.sales,
    totalRows: state => state.sales.totalCounts,
    currentUser: state => state.auth.currentUser
  }),
  methods: {
    arrayIntersection(array, targetArray) {
      return arrayIntersection(array, targetArray);
    },
    searchSalesContract() {},
    openCreateSalesContractDrawer() {
      this.$refs.CreateSalesContractDrawer.openDrawer();
    }
  }
};
</script>
<style lang="stylus" scoped>
.handle-wrapper
  width 100%
  height 48px
  display flex
  align-items center
  justify-content flex-end

.table-wrapper
  width 100%
  height calc(100% - 48px)
</style>